'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDeveloperBoard = function MdDeveloperBoard(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 18.4h6.6v10h-6.6v-10z m-10-6.8h8.4v8.4h-8.4v-8.4z m10 0h6.6v5h-6.6v-5z m-10 10h8.4v6.8h-8.4v-6.8z m20 10v-23.2h-23.4v23.2h23.4z m6.6-16.6h-3.2v3.4h3.2v3.2h-3.2v3.4h3.2v3.4h-3.2v3.2c0 1.8-1.6 3.4-3.4 3.4h-23.4c-1.8 0-3.2-1.6-3.2-3.4v-23.2c0-1.8 1.4-3.4 3.2-3.4h23.4c1.8 0 3.4 1.6 3.4 3.4v3.2h3.2v3.4z' })
        )
    );
};

exports.default = MdDeveloperBoard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/developer-board.js
// module id = 1366
// module chunks = 168707334958949